import styled from 'styled-components';

export const FormWrapper = styled.div`
  .btn-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
